import Badge from './ColoredLabel';

export default Badge;
